module.exports = __webpack_public_path__ + "img/cursor-hand.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=img/cursor-hand.png!./src/img/cursor-hand.png
// module id = 2506
// module chunks = 0